/* eslint-disable max-len */
// Support redirect
const SUPPORT_EMAIL = "Support Portal"
const SUPPORT_REFER_ENTITY = `our support team by raising a ticket on our ${SUPPORT_EMAIL}`
const SUPPORT_REFER_HELP_DESK = `contact ${SUPPORT_REFER_ENTITY}`
const SUPPORT_REFER_FULL = `If this persists, you should ${SUPPORT_REFER_HELP_DESK}`

// Display detail error messages - these get displayed to the user
const GENERIC_DISPLAY_DETAIL = `Something went wrong whilst trying to perform this action for you. ${SUPPORT_REFER_FULL}`
const NO_PERMISSION_DISPLAY_DETAIL = `You do not have permission to carry out this action. Please speak to your admin for support in getting access`

// Technical error detail messages - these get logged to the console
const GENERIC_AXIOS_TECHNICAL_DETAIL =
    "This API (axios) error was not captured by the application error handler. You should investigate the error and add it to the recognised errors list error"
const PYDANTIC_ERROR_TECHNICAL_DETAIL =
    "Axios raised a 422. This is mostly likely because the request failed validation in pydantic."
const GENERIC_UNRECOGNISED_TECHNICAL_DETAIL =
    "An unrecognised error was passed to the application error handler. This was handled via the generic catch all. You should investigate the error and add it to the recognised errors list"
const NO_PERMISSION_TECHNICAL_DETAIL =
    "User does not have permission to carry out this action"
export {
    GENERIC_DISPLAY_DETAIL,
    SUPPORT_REFER_ENTITY,
    SUPPORT_EMAIL,
    SUPPORT_REFER_FULL as SUPPORT_REFER,
    SUPPORT_REFER_HELP_DESK,
    GENERIC_AXIOS_TECHNICAL_DETAIL,
    PYDANTIC_ERROR_TECHNICAL_DETAIL,
    GENERIC_UNRECOGNISED_TECHNICAL_DETAIL,
    NO_PERMISSION_TECHNICAL_DETAIL,
    NO_PERMISSION_DISPLAY_DETAIL,
}
